module.exports = __webpack_public_path__ + "img/webinarAnimations.894c49c1.gif";